import { render, staticRenderFns } from "./JerseyButtonYellow.vue?vue&type=template&id=2201f9bb&scoped=true&"
import script from "./JerseyButtonYellow.vue?vue&type=script&lang=ts&"
export * from "./JerseyButtonYellow.vue?vue&type=script&lang=ts&"
import style0 from "./JerseyButtonYellow.vue?vue&type=style&index=0&id=2201f9bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2201f9bb",
  null
  
)

export default component.exports